import { EmergencyFundHeader } from './emergency-fund/EmergencyFundHeader';
import { MajorPurchaseHeader } from './major-purchase/MajorPurchaseHeader';

import { Purpose } from '../../data';

export const HeaderContent: React.FC<{ purpose: Purpose }> = ({ purpose }) => {
  switch (purpose.__typename) {
    case 'PurposeMajorPurchase':
      return <MajorPurchaseHeader purpose={purpose} />;
    case 'PurposeEmergencyFund':
      return <EmergencyFundHeader purpose={purpose} />;
    case 'PurposeRetirementGrowth':
    case 'PurposeRetirementIncome':
    default:
      return null;
  }
};
